import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import 'less/snackbar.less'

const Snackbar = props => (
  <div className={`${props.className} ${props.open ? 'show' : ''}`}>
    {(props.className == 'copy-screeners-snackbar' || props.className == 'error-snackbar copy-screeners-snackbar-link') &&
      <i className="im-close2" onClick={() => props.dispatchAction('DISMISS_SNACKBAR')}/>
    }
    {props.title && props.title.length > 1 && <div className='title'> {props.title} </div>}
    {props.message}
    {props.actionType ?
      <button className="action" onClick={() => props.dispatchAction(props.actionType)}>{props.actionText}</button> :
      undefined
    }
  </div>
)

Snackbar.propTypes = {
  open: PropTypes.bool,
  className: PropTypes.string,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  actionText: PropTypes.string,
  actionType: PropTypes.string,
}

const mapState = state => ({
  open: state.snackbar.open,
  message: state.snackbar.message,
  actionType: state.snackbar.actionType,
  actionText: state.snackbar.actionText,
  className: state.snackbar.className,
  title: state.snackbar.title
})

const mapDispatch = ({
  dispatchAction: type => ({ type }),
})

export default connect(mapState, mapDispatch)(Snackbar)
